module.exports = __webpack_public_path__ + "img/logo_square.6247ba0f.png";